module.exports = __webpack_public_path__ + "img/qiye_renyuan.7800ec66.png";